/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegisterPushTokenRequest } from '../models/RegisterPushTokenRequest';
import type { RemovePushTokenRequest } from '../models/RemovePushTokenRequest';
import type { SendAnnouncementRequest } from '../models/SendAnnouncementRequest';
import type { SendOrderNotificationRequest } from '../models/SendOrderNotificationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PushNotificationService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiPushNotificationPushToken(
        requestBody?: RegisterPushTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PushNotification/PushToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiPushNotificationPushToken(
        requestBody?: RemovePushTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/PushNotification/PushToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiPushNotificationSendNewOrderNotification(
        requestBody?: SendOrderNotificationRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PushNotification/SendNewOrderNotification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiPushNotificationSendAnnouncement(
        requestBody?: SendAnnouncementRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PushNotification/SendAnnouncement',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
